export const pie = (props: {[key: string]: any} = {}, data: { [ key: string ]: {[key: string]: any}|string[]} = {}) => {
    let legendOptions: { [ key: string ]: string | number | {[key: string]: string} } = {
        show: props.showLegend,
        type: 'scroll',
        textStyle: {
            color: props.color
        }
    };

    switch (props.legendPosition) {
        case 'bottom':
            legendOptions = { ...legendOptions, bottom: 0 }
            break;
    }

    return {
        tooltip: {
            trigger: 'item',
            formatter: `{b}:<br>${props.prefix ? props.prefix : ''}{c}${props.suffix ? props.suffix : ''}`
        },
        title: {
            show: false
        },
        textStyle: {
            color: props.color,
            fontFamily: props.fontFamily,
        },
        series: data.series || [],
        legend: legendOptions,
        animation: props.animation,
        grid: {containLabel: true}
    }
}